const SERVICES = [
  {
    id: "field_os",
    name: "Field OS",
    icon: "workspaces",
    path: "/field",
    description: "Field activities workspace",
  },
  {
    id: "voice",
    name: "Voice",
    icon: "dialer_sip",
    path: "/voice",
    description: "Call center workspace",
  },
  {
    id: "wacc",
    name: "Whatsapp",
    icon: "forum",
    path: "/wacc",
    description: "Whatsapp communication workspace",
  },
];

export default SERVICES;
